import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { alert_error } from "../../AppContext.js";
import SupportButton from '../../community/SupportButton.jsx';
import { update_open_button_support } from '../../order/orders/actions.js';
import { useSelector, useDispatch } from 'react-redux';
import { Cookies } from '../../index.js';
const TaskList = () => {
  const open_button_support = useSelector(state => state.open_button_support);
  const dispatch = useDispatch();

  const set_open_button_support = (value) => {
    dispatch(update_open_button_support(value));
  };
  const [datahome, setDatahome] = useState({
    links: [{ to: "", text: "Please wait a moment 😊 ..." }],
  });
  const [status_lists, set_status_lists] = useState('');
  useEffect(() => {
    setDatahome({
      links: [
        {
          to: "/shop/donate/acb/block",
          text: "Gỡ khóa tài khoản bằng cách chuyển khoản ngân hàng",
        },
        {
          to: "/shop/donate/me/block",
          text: "Chuyển coin để từ tài khoản khác",
        },
        {
          to: "/ai/plans/un_block_users",
          text: "Trừ coin tài khoản để mở khóa ",
        },
        {
          to: "/shop/support",
          text: "Liên hệ bộ phận hỗ trợ",
        },
      ],
    });
    fetchData();
  }, []);

  const fetchData = () => {
    const apikey = Cookies.get('apikey');
    axios
      .get("https://hust.media/api/profile/users_status_lists.php", {
        params: {
          apikey: apikey
        }
      })
      .then((response) => {
        set_status_lists(response.data);
      })
      .catch((error) => {
        alert_error(error);
      });
  };
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  function switch_router(link) {
    if (link == "/shop/support") {
      set_open_button_support(!open_button_support);
    }
    else {
      navigate(link);
    }
  };
  return (
    <div className="max-w-5xl mx-auto p-4">
      <div className="bg-white p-6 rounded-lg shadow-lg">
        <h1 className="text-lg font-semibold text-center text-red-600 mb-4">
          Lý do khóa: {status_lists.block_reason}
        </h1>
        <p className="text-center text-gray-700 font-medium mb-6">
          Vui lòng lựa chọn một trong hai cách dưới đây để gỡ khóa:
        </p>
        <div className="grid grid-cols-1 gap-4">
          {datahome.links.map((link, index) => (
            <button
              key={index}
              onClick={() => switch_router(link.to)}
              className="block text-center bg-white text-black border-2 border-black rounded-xl px-4 py-2 transition hover:bg-black hover:text-white dark:bg-gray-800 dark:text-gray-100 dark:border-gray-500 dark:hover:bg-gray-700"
              style={{ textDecoration: "none" }}
            >
              <span className="text-base font-medium">{link.text}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TaskList;